import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import logo from "../img/wecodxtechlogo-m-width.png";


const footerLinks = {
  company: [
    { name: "Who Are We", path: "/about" },
    { name: "What We Do", path: "/services" },
    // { name: "Products", path: "/products" },
    { name: "Connect with us", path: "/contact" },
  ],
  services: [
    { name: "Software Development", path: "/services" },
    { name: "Web Development", path: "/services" },
    { name: "E-Commerce Development", path: "/services" },
    { name: "Digital Marketing", path: "/services" },
  ],
  programs: [
    { name: "Internships", path: "" },
    { name: "Certifications", path: "" },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-neutral-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img src={logo} alt="wecodXtech" className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Building the future of technology. We deliver innovative software solutions, 
              digital transformation, and nurture the next generation of tech talent.
            </p>
            <div className="space-y-3">
              <a
                href="mailto:wecodxtech@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-slate-400 hover:text-white text-sm transition-colors"
              >
                <Mail size={16} className="text-blue-500" />
                wecodxtech@gmail.com
              </a>
              {/* <a
                href="tel:+917810097316"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-slate-400 hover:text-white text-sm transition-colors"
              >
                <Phone size={16} className="text-blue-500" />
                +91 7810097316
              </a> */}
              <div className="flex items-center gap-3 text-slate-400 text-sm">
                <MapPin size={16} className="text-blue-500 shrink-0" />
                India
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wider uppercase mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-slate-400 hover:text-white text-sm transition-colors flex items-center gap-1 group"
                  >
                    {link.name}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wider uppercase mb-6">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm transition-colors flex items-center gap-1 group"
                  >
                    {link.name}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wider uppercase mb-6">Programs</h4>
            <ul className="space-y-3">
              {footerLinks.programs.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm transition-colors flex items-center gap-1 group"
                  >
                    {link.name}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} wecodXtech. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-slate-500 text-xs">Privacy Policy</span>
            <span className="text-slate-500 text-xs">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
